import { FORM_TYPES } from "../../_configuration/routing/constants"

const formsPath = `forms/`

export const S3_PATHS = {
    COMPLIANCE: `public/compliance.pdf`,
    COUNTRIES: `public/countries.json`,
    FORMS: {
        [FORM_TYPES.FOREIGN_CONTRACTS]: `${formsPath}contracts.json`,
        [FORM_TYPES.FOREIGN_GIFTS]: `${formsPath}gifts.json`,
    }
}